// src/hooks/useStreak.ts
import useSWR from 'swr';
import { doc, getDoc } from 'firebase/firestore';
import { db, appId } from '../firebase';
import { StreakData } from '../types/index'; // Ad型とProfile型をインポート


const fetchStreak = async (userId: string): Promise<StreakData> => {
    if (!userId) return { streakDays: 0, lastCompletionDate: '', completionDateList: [] };

    const ref = doc(db, `artifacts/${appId}/users/${userId}/userData`, 'ChallengeQuizSelection');
    const snap = await getDoc(ref);

    if (!snap.exists()) {
        return { streakDays: 0, lastCompletionDate: '', completionDateList: [] };
    }

    const data = snap.data();
    return {
        streakDays: data.streakDays || 0,
        lastCompletionDate: data.lastCompletionDate || '',
        completionDateList: Array.isArray(data.completionDateList) ? data.completionDateList : [],
    };
};

export const useStreak = (userId: string) => {
    const { data, error, isLoading, mutate } = useSWR(userId ? ['streak', userId] : null, () => fetchStreak(userId));

    return {
        streakDays: data?.streakDays || 0,
        lastCompletionDate: data?.lastCompletionDate || '',
        completionDateList: data?.completionDateList || [],
        isLoading,
        error,
        mutate,
    };
};
